import React from "react";
import { useRoutes } from "react-router-dom";
import { withRouter } from "../../util/with-router";
import { TransitionGroup } from "react-transition-group";
import AddSupplier from "./add-supplier";
import SuppliersList from './list';
import SuppliersPurchaseOrderList from './purchase-order/po-list';
import ViewPurchaseOrder from './purchase-order/view-po';
import CreatePurchaseOrder from './purchase-order/create-po';
import SupplierInvoiceList from './vendor-payment/list';
import ViewInvoicePurchaseOrder from './vendor-payment/view-invoice';
import RBACApplicationAuth from "../../layout/rbac";
import * as paths from "../../constants/route-paths";
import ImportVendors from "../../components/bulk-vendor-import";
import InvoiceManagement from './invoice-management/InvoiceManagement';

function CustomRoutes({ location }) {
    let element = useRoutes([
        {
            path: paths.SUPPLIERS_LIST,
            element: <RBACApplicationAuth moduleURL={location.pathname} component={SuppliersList} />,
        },
        {
            path: paths.ADD_SUPPLIER,
            element: <RBACApplicationAuth moduleURL={location.pathname} component={AddSupplier} />,
        },
        {
            path: paths.EDIT_SUPPLIER,
            element: <RBACApplicationAuth moduleURL={location.pathname} component={AddSupplier} />,
        },
        {
            path: paths.PURCHASE_ORDER,
            element: <RBACApplicationAuth moduleURL={location.pathname} component={SuppliersPurchaseOrderList} />,
        },
        {
            path: paths.VIEW_PURCHASE_ORDER,
            element: <RBACApplicationAuth moduleURL={location.pathname} component={ViewPurchaseOrder} />,
        },
        {
            path: paths.CREATE_PURCHASE_ORDER,
            element: <RBACApplicationAuth moduleURL={location.pathname} component={CreatePurchaseOrder} />,
        },
        {
            path: paths.EDIT_PURCHASE_ORDER,
            element: <RBACApplicationAuth moduleURL={location.pathname} component={CreatePurchaseOrder} />,
        },
        {
            path: paths.VENDOR_PAYMENT,
            element: <RBACApplicationAuth moduleURL={location.pathname} component={SupplierInvoiceList} />,
        },
        {
            path: paths.VIEW_INVOICE_PO,
            element: <RBACApplicationAuth moduleURL={location.pathname} component={ViewInvoicePurchaseOrder} />,
        },
        {
            path: paths.IMPORT_SUPPLIERS,
            element: <RBACApplicationAuth moduleURL={location.pathname} component={ImportVendors} />,
        },
        {
            path: paths.INVOICE_MANAGEMENT,
            element: <RBACApplicationAuth moduleURL={location.pathname} component={InvoiceManagement} />,
        },
    ]);

    return element;
}

class Root extends React.PureComponent {
    render() {
        const { location } = this.props;
        return (
            <div className="clearfix" style={{ width: "100%" }}>
                <TransitionGroup>
                    <CustomRoutes location={location} />
                </TransitionGroup>
            </div>
        );
    }
}
export default withRouter(Root);
